import { useState, useEffect } from "react";
import * as firebase from "firebase";

import { parseDocSnapshot } from "hooks/utils";

export const useComments = (exerciseId) => {
  const [comments, setComments] = useState();
  useEffect(() => {
    setComments();
    return firebase
      .firestore()
      .collection("comments")
      .where("exerciseId", "==", exerciseId)
      .onSnapshot(snapshot => {
        const newDocs = [];
        snapshot.forEach(docSnapshot => {
          const doc = parseDocSnapshot(docSnapshot);
          newDocs.push(doc);
        });
        setComments(newDocs);
      });
  }, [exerciseId]);
  return comments
}
